module.exports = __webpack_public_path__ + "img/download_black.ab1185f4.svg";